export const CSS_API_URL = "./data/cssbasicData.json";
export const FLEX_BOX_API_URL = "./data/flexboxData.json";
export const GRID_API_URL = "./data/gridData.json";
export const ANIMATION_API_URL = "./data/animationData.json";
export const SASS_API_URL = "./data/sassData.json";
